/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import { useGetAccountsQuery } from "~/generated/graphql";
import { ROUTES } from "~/routing/routes";

type Props = {
  cloudAccountId: string | undefined;
};

export function AccountLink({ cloudAccountId }: Props) {
  const { link, label } = useAccountLink(cloudAccountId ?? "");
  return (
    <Link style={{ display: "block" }} to={link}>
      {label}
    </Link>
  );
}

function useAccountLink(cloudAccountId: string, skipNetworkFetch?: boolean) {
  const { data, loading } = useGetAccountsQuery({
    fetchPolicy: "cache-first",
    skip: skipNetworkFetch,
  });

  const currentAccount = data?.accounts?.find(
    (acc) => acc?.providerId === cloudAccountId
  );

  const link = currentAccount
    ? `${ROUTES.cloudAccounts.index}/${currentAccount.nid}`
    : `${ROUTES.estateRecords.index}?account[0]=${cloudAccountId}`;

  const label = currentAccount ? currentAccount.name : cloudAccountId;

  return {
    link,
    label,
    loading,
  };
}
